// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"67f1aee1","920":"67f1aee1"}[chunkId] + ".chunk.css";
};